import { getEventPropsBuilder, toSnakeCase } from '../../utils';
import type { AmplitudeEventKeys } from '../../amplitude-properties.types';

type CategoryPageViewedEvent = {
    category?: string;
    pageName: string;
    tag?: string;
    navigationSource?: string;
};

export const getCategoryPageViewedProps = getEventPropsBuilder(
    (e: CategoryPageViewedEvent): Partial<AmplitudeEventKeys> => {
        return {
            event: 'Category Page Viewed',
            Category: (e?.category && toSnakeCase(e.category)) || '',
            'Page Name': toSnakeCase(e.pageName),
            Tag: e.tag || '',
            'Navigation Source': e.navigationSource || ''
        };
    }
);
